import React, { FC } from "react"

import { CtaFragmentFragment } from "@graphqlTypes"

import CTA from "@components/CTA/CTA"
import LpSection from "../LpSection/LpSection"

const CtaBlock: FC<CtaFragmentFragment> = ({
  blockBackground,
  blockIncludeBackground,
  blockMarginBottom,
  blockUseDarkMode,
  ...props
}) => (
  <LpSection
    background={blockBackground}
    includeBackground={blockIncludeBackground}
    marginBottom={blockMarginBottom || "S"}
    uniqueId={props.contentful_id}
    useDarkMode={blockUseDarkMode}
  >
    <div className="container">
      <div className="grid">
        <div className="column">
          <CTA {...props} />
        </div>
      </div>
    </div>
  </LpSection>
)

export default CtaBlock
